import { Component, OnInit, OnDestroy } from "@angular/core";
import { MuestraService } from '../../servicios/muestra-servicios';
import { LogService } from "../../servicios/log-servicios";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";


@Component({
  selector: 'app-msgbox-elem',
  templateUrl: './msgbox-elem.component.html',
  styleUrls: ['./msgbox-elem.component.css']
})
export class MsgboxElemComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();

  muestraMsgboxSub: Subscription;
  muestraMsgbox: boolean = false;
  mbTitulo: string = '';
  mbTexto1: string = '';
  mbTexto2: string = '';
  mbBotones: string = '';
  mbIcono: string = '';
  mbRespuesta: string = '';

  vfAceptar: boolean = false;
  tiempoAceptar: string = '';
  vfCancelar: boolean = false;
  vfSi: boolean = false;
  vfNo: boolean = false;
  vfSalir: boolean = false;
  cantBotones: number = 0;
  lineaBotonesStyle: object;
  botonStyle: object;

  constructor(
    private muestraService: MuestraService,
    private logService: LogService
  ) { }

  emitirRespuesta(resp: string) {
    this.muestraService.ocultaMsgbox(resp);
  }

  timerAceptar = setInterval(() => {
    switch (this.tiempoAceptar) {
      case '3s':
        this.tiempoAceptar = '2s';
        break;
      case '2s':
        this.tiempoAceptar = '1s';
        break;
      case '1s':
        this.tiempoAceptar = '0s';
        break;
      default:
        this.tiempoAceptar = '';
        break;
    }
    if (this.tiempoAceptar == '0s') {
      this.emitirRespuesta('Aceptar');
      clearTimeout(this.timerAceptar);
    } else if (this.tiempoAceptar == '') {
      clearTimeout(this.timerAceptar);
    }
  }, 1000);



  ngOnInit() {
    this.logService.consoleLog('2', 'CE MB init');
    this.muestraMsgboxSub = this.muestraService.msgbox$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraMsgbox = p;
        if (this.muestraMsgbox) {
          //leo los paráms para mostrar en el html
          this.logService.consoleLog('2', 'CE MB mMb true');
          this.mbTitulo = this.muestraService.mbTitulo;
          this.mbTexto1 = this.muestraService.mbTexto1;
          this.mbTexto2 = this.muestraService.mbTexto2;
          this.mbBotones = this.muestraService.mbBotones;
          this.mbIcono = this.muestraService.mbIcono;
          this.mbRespuesta = '';
          //El campo mbBotones por ahora puede ser: Aceptar, Aceptar1s, Aceptar2s, Aceptar3s, Salir, AceptarCancelar, SiNo, SiNoSalir
          switch (this.mbBotones) {
            case 'Aceptar':
              this.vfAceptar = true;
              this.cantBotones = 1;
              break;
            case 'Aceptar1s':
              this.vfAceptar = true;
              this.cantBotones = 1;
              this.tiempoAceptar = '1s';
              //esta función es un interval q disminuye el tiempoAceptar cada segundo hasta llegar a 0
              this.timerAceptar;
              break;
            case 'Aceptar2s':
              this.vfAceptar = true;
              this.cantBotones = 1;
              this.tiempoAceptar = '2s';
              //esta función es un interval q disminuye el tiempoAceptar cada segundo hasta llegar a 0
              this.timerAceptar;
              break;
            case 'Aceptar3s':
              this.vfAceptar = true;
              this.cantBotones = 1;
              this.tiempoAceptar = '3s';
              //esta función es un interval q disminuye el tiempoAceptar cada segundo hasta llegar a 0
              this.timerAceptar;
              break;
            case 'Salir':
              this.vfSalir = true;
              this.cantBotones = 1;
              break;
            case 'AceptarCancelar':
              this.vfAceptar = true;
              this.vfCancelar = true;
              this.cantBotones = 2;
              break;
            case 'SiNo':
              this.vfSi = true;
              this.vfNo = true;
              this.cantBotones = 2;
              break;
            case 'SiNoSalir':
              this.vfSi = true;
              this.vfNo = true;
              this.vfSalir = true;
              this.cantBotones = 3;
              break;
            default:
              break;
          }
          switch (this.cantBotones) {
            case 1:
              this.lineaBotonesStyle = { padding: '2px 20px' };
              this.botonStyle = { width: '100%', margin: '5px' };
              break;
            case 2:
              this.lineaBotonesStyle = { padding: '2px 10px' };
              this.botonStyle = { width: '50%', margin: '5px' };
              break;
            case 3:
              this.lineaBotonesStyle = { padding: '2px 2px' };
              this.botonStyle = { width: '33%', margin: '5px' };
              break;
            default:
              break;
          }
        } else {
          //nada
          this.logService.consoleLog('2', 'CE MB mMb false');
        }
      })
  }

  ngOnDestroy() {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this.logService.consoleLog('2', 'CE MB cerrando msgbox-elem.component');
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
